module.exports = __webpack_public_path__ + "static/media/chosen.fm.62cc27d4.png";